import superMeta from '../_CATEGORY_ROOT/metaCategoryRootNode.mjs'

export default {
    ...superMeta,
    name: '部署模型',
    type: 'CAT_ROOT_DEP',
}
